export default __webpack_public_path__ + "static/media/icon-date_range.f232a20b.svg";